import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats time in xx:xx format
 */

@Pipe({
  name: 'formatTime',
})
export class TimeFormatPipe implements PipeTransform {
  transform(timestamp: number): string {
    if (!timestamp) { return '0:00'; }

    timestamp = Math.round(timestamp);

    const minutes = Math.floor(timestamp / 60),
      seconds = timestamp - minutes * 60;
    const _seconds = seconds < 10 ? '0' + seconds : seconds;

    return minutes + ':' + _seconds;
  }
}
